import { ExpandableCard } from "@certn/cascadia-react";
import { Skeleton } from "@certn/cascadia-react/patterns/skeleton/Skeleton";
import { Text } from "@certn/forms/src/components/Text";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";

import { BillingAddressForm } from "./BillingAddressForm";
import { useOrderBillingProfile } from "../../../pages/order/steps/useOrderBillingProfile";

export function BillingAddress() {
  const { t } = useTranslation();
  const onToggle = useCallback(() => setIsExpanded((prev) => !prev), []);
  const { data: profile, isLoading } = useOrderBillingProfile();
  const [isExpanded, setIsExpanded] = useState(
    !profile?.address.address_line_1
  );

  if (!profile) {
    if (isLoading) {
      return (
        <ExpandableCard
          title={
            <Text style="global/heading-medium">{t("Billing address")}</Text>
          }
          subtitle={<Skeleton count={3} width={120} />}
        />
      );
    }

    return null;
  }

  const { address_line_1, locality, postal_code } = profile.address;

  return (
    <ExpandableCard
      expanded={isExpanded}
      onToggle={onToggle}
      title={<Text style="global/heading-medium">{t("Billing address")}</Text>}
      iconLabel={profile.address && !isExpanded ? t("Edit") : undefined}
      subtitle={
        !isExpanded &&
        profile.address.address_line_1 && (
          <Text style="form/body-secondary" color="text-weak">
            {address_line_1}
            <br />
            {locality}
            <br />
            {postal_code}
          </Text>
        )
      }
    >
      {isExpanded && <BillingAddressForm onSave={onToggle} />}
    </ExpandableCard>
  );
}
